import { Search, UserPlus } from 'lucide-react';

import { Button } from '~shared/shadcn/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~shared/shadcn/ui/dialog';

interface AddFamilyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContactSearchOpen: (open: boolean) => void;
  onManualEntryOpen: (open: boolean) => void;
}

export const AddFamilyDialog = ({
  open,
  onOpenChange,
  onContactSearchOpen,
  onManualEntryOpen,
}: AddFamilyDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='p-10 sm:max-w-[700px]'>
        <DialogHeader className='mb-8'>
          <DialogTitle className='text-center text-4xl font-semibold'>
            Add a Family
          </DialogTitle>
          <DialogDescription className='text-center text-lg font-medium'>
            Create a parent and send login credentials
          </DialogDescription>
        </DialogHeader>

        <div className='flex flex-col gap-4'>
          <Button
            variant='outline'
            className='h-20 w-full gap-4 p-4'
            onClick={() => {
              onOpenChange(false);
              onContactSearchOpen(true);
            }}
          >
            <Search className='size-6 text-yellow-500' />
            <div className='flex flex-1 flex-col items-start'>
              <span className='text-lg font-bold'>
                Search Existing Contacts
              </span>
              <span className='text-sm text-muted-foreground'>
                Import details from your contact list
              </span>
            </div>
          </Button>

          <Button
            variant='outline'
            className='h-20 w-full gap-4 p-4'
            onClick={() => {
              onOpenChange(false);
              onManualEntryOpen(true);
            }}
          >
            <UserPlus className='size-6 text-yellow-500' />
            <div className='flex flex-1 flex-col items-start'>
              <span className='text-lg font-bold'>Manual Entry</span>
              <span className='text-sm text-muted-foreground'>
                Enter parent details manually
              </span>
            </div>
          </Button>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant='outline'>Cancel</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
